<template>
  <div class="content none-click">
    <div class="page">
      <div class="case">
        <div class="title">
          <div class="title-left">
            <img src="@/assets/Mobile/images/icon/icon-newsCenter-1.png">
            <div class="text">客户案例</div>
          </div>
          <div class="title-right" @click="seeMoreClick('reportList')">
            <div class="more">更多</div>
            <img src="../../assets/right-arrow.png" alt="">
          </div>
        </div>
        <div class="content">
          <div v-for="(item, index) in caseList" :key="index" class="item">
            <div @click="linkTo(item.id)">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="case">
        <div class="title">
          <div class="title-left">
            <img src="@/assets/Mobile/images/icon/icon-newsCenter-2.png">
            <div class="text">视频中心</div>
          </div>
          <div class="title-right" @click="seeMoreClick('videoList')">
            <div class="more">更多</div>
            <span />
          </div>
        </div>
      </div> -->
      <div class="case">
        <div class="title">
          <div class="title-left">
            <img src="@/assets/Mobile/images/icon/icon-newsCenter-3.png">
            <div class="text">媒体资料库</div>
          </div>
          <div class="title-right" @click="seeMoreClick('mediaList')">
            <div class="more">更多</div>
            <img src="../../assets/right-arrow.png" alt="">
          </div>
        </div>
        <div class="content">
          <div v-for="(item, index) in mediaList" :key="index" class="item">
            <div @click="linkTo(item.id)">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>

      <div v-infinite-scroll="loadMore" class="dataList" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
        <div v-for="(item, index) in dataList" :key="index" class="">
          <div class="item flexbox-row" @click="linkTo(item.id)">
            <div class="image">
              <img v-if="item.picUrl" :src="item.picUrl">
              <img v-else src="../../assets/default-logo.jpg">
            </div>
            <div class="item-content">
              <div class="title">
                {{ item.title }}
              </div>
              <div class="content">
                {{ item.introduction }}
              </div>
              <div class="bottom">
                {{ item.createTime }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- <Case title="金融服务" />
    <ContactForm info-sources="金融服务" /> -->
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import Case from '@/Mobile/Mobilecom/Case'

import { getNewsList } from '@/apis/index.js'
import moment from 'moment'

export default {
  metaInfo: metaInfo.Finance,
  components: {
    ContactForm,
    Case
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      // 新闻数据
      dataList: [],
      // 客户案例数据
      caseList: [],
      // 媒体资料库
      mediaList: [],
      isMore: true
    }
  },
  mounted() {
    this.getNewsList()
    this.getcaseList()
    this.getMediaList()
  },
  methods: {
    loadMore() {
      if (this.isMore) {
        this.page += 1
        this.getNewsList()
      }
    },
    // 跳转详情
    linkTo(id) {
      this.$router.push({ path: 'newsDetail', query: { id }})
    },

    // 获取新闻数据
    async getNewsList() {
      const { page, pageSize } = this
      await getNewsList({ page, rows: pageSize, type: 1 }).then(res => {
        res.forEach(v => {
          if (v.picUrl) {
            v.picUrl = 'https://static.htd.cn/' + v.picUrl
          }
          v.createTime = moment(v.createTime).format('YYYY-MM-DD')
        })
        this.isMore = res.length > 0
        this.dataList = this.dataList.concat(res)
      }).catch(e => {
      })
    },
    // 获取客户案例数据
    async getcaseList() {
      await getNewsList({ page: 1, rows: 5, type: 3 }).then(res => {
        this.caseList = res
      }).catch(e => {
      })
    },
    // 获取媒体资料库数据
    async getMediaList() {
      await getNewsList({ page: 1, rows: 5, type: 4 }).then(res => {
        this.mediaList = res
      }).catch(e => {
      })
    },
    // 案例查看更多
    seeMoreClick(path) {
      this.$router.push({ path })
    }
  }
}
</script>

<style lang="less" scoped>
.content{
    font-size: 12px;
}
.title-right{
  display: flex;
  align-items: center;
  flex-direction: row;

  .more {
    font-size: 14px;
    line-height: 15px;
  }

  img {
    margin-top: -1px;
    width: 12px;
  }
}

.page{
  padding-top: 0.8rem;
  margin-top: 20px;
  text-align: left;
}
.dataList{
  margin: 15px 0 30px;
  padding: 0 19px;
  .item{
    display: flex;
    flex-direction: row;
    height: 100%;
    padding: 19px 0;
    border-top: 1px solid #f2f2f2;
    .image{
      width: 100px;
      height: 63px;
      img{
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }

    .item-content{
      width: 70%;
      margin-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title{
        font-size: 14px;
        line-height: 18px;
        color: #2C3E50;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
      }
      .content{
          font-size: 11px;
          line-height: 15px;
          color: #ACB1B5;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
      }
      .bottom{
        text-align: left;
        font-size: 11px;
        line-height: 12px;
        color: #ACB1B5;

      }
    }
  }
}
.case{
  padding: 19px;
  text-align: left;
  .more{
    color: #a0a0a0;
  }
  .title{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;
    .title-left{
      display: flex;
      flex-direction: row;
      align-items: center;
        img{
          width: 19px;
          height: 19px;
          margin-right: 4px;
        }
       .text{
         font-size: 18px;
         color: #000;
         font-weight: bold;
      }
    }

  }
  .content{
    .item{
      padding-bottom: 18px;
      font-size: 14px;
      line-height: 15px;
      color: #2C3E50;
      div {
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
    }

    .item:last-of-type {
      padding-bottom: 0;
    }
  }
}
.seeMore{
  text-align: center;
}

</style>
